import type { CommonStore } from './interfaces'

export const getters = {
  isLoading: (state: CommonStore): CommonStore['loading'] => state.loading,
}
